/** Navigational tree item.  */
export class RdsNavTreeItem {
  constructor(public icon: string, public label: string, public url: string, public children?: RdsNavTreeItem[]) {}
}
